var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoc = function SvgDoc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "07225D46-3F51-410E-90B4-A47644440D67") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Historia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Botwise---Historia-zmian---Filtry-Expand-Stany",
    transform: "translate(-332.000000, -771.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(326.000000, 765.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-02-copy",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3043478,16 L0.695652174,16 C0.311453913,16 0,15.6885461 0,15.3043478 L0,0.695652174 C0,0.311453913 0.311453913,0 0.695652174,0 L15.3043478,0 C15.6885461,0 16,0.311453913 16,0.695652174 L16,15.3043478 C16,15.6885461 15.6885461,16 15.3043478,16 Z",
    id: "Path",
    fill: "#4B88E5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "W",
    fill: "#FFFFFF",
    points: "6.83901919 12 7.98081023 7.23529412 8 7.23529412 9.16098081 12 10.6577825 12 12.5 5 11.0223881 5 9.89978678 9.82352941 9.88059701 9.82352941 8.71002132 5 7.29957356 5 6.1098081 9.76470588 6.09061834 9.76470588 5.00639659 5 3.5 5 5.31343284 12"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc.ab2072959a80e0ed8d55ad6d85264cc5.svg";